export default "__VITE_ASSET__Cmh2pXTk__"